import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgDialogAnimationService } from 'src/app/services/core/ng-dialog-animation.service';
import { finalize, first, map, Subject, takeUntil } from 'rxjs';
import { VendorDataService } from 'src/app/modules/inventory/vendor/vendor.data.service';
import { BidDataService } from 'src/app/modules/sale/bid/bid.data.service';
import { JobDataService } from 'src/app/modules/sale/job/job.data.service';
import { QuickVendorComponent } from 'src/app/modules/sale/proposal/form-part/quote/create-proposal-scope-product/quick-vendor/quick-vendor.component';
import { TaskDataService } from 'src/app/modules/sale/task/task.data.service';
import { BackendApiService } from 'src/app/services/backend-api.service';
import { DialogService } from 'src/app/services/core/dialog.service';
import { ToasterService } from 'src/app/services/core/toaster.service';
import { CurrencyMaskOptions } from '../../shared.constants';
import { VendorQuoteDataService } from '../vendor-quote-data.service';
import { CoreService } from 'src/app/services/core/core.service';
import { DatePipe } from '@angular/common';
import { ScopeDataService } from 'src/app/modules/setting/scope/scope.data.service';
import { environment } from 'src/environments/environment';
import { ProposalDataService } from 'src/app/modules/sale/proposal/proposal.data.service';
import { ProductDataService } from 'src/app/modules/inventory/product/product.data.service';

@Component({
    selector: 'app-add-edit-vendor-quotes',
    templateUrl: './add-edit-vendor-quotes.component.html',
    styleUrls: ['./add-edit-vendor-quotes.component.scss'],
    standalone: false
})
export class AddEditVendorQuotesComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  public vendors: any = [];
  public vendorsQuoteList: any = [];
  isVendorQuoteModule: boolean = false
  showSearchInput: boolean = true;
  modulesList: any = [];
  module_id: any = 12;
  searchParams = {
    type: '',
    module_id: '',
    search: ''
  };

  selectedItem: any = {};
  selectedStage: any = {};
  stages: any = [];
  vendorQuoteId: any
  public isSaving = false;
  moduleId: any
  referenceId: any;
  isEditMode: boolean = false
  vendorDetail: any
  vendorId: any
  isVendorModule: boolean = false
  public currencyMaskOptions = CurrencyMaskOptions;
  isVendorDisabled: boolean = false;
  public scopes: any = [];
  public selectedScopes: any[] = [];
  public selectedProducts: any[] = [];
  public availableProducts: any[] = [];
  public loadingProducts: boolean = false;
  public activeTab: string = 'information';
  public temporaryFormData: any = null;
  public uploadedAttachments: any[] = [];
  /** Files in app-attachment's own shape ({attach_file, attachment_id}), to show them when the Uploads tab opens. */
  public uploaderFiles: any[] = [];
  /** Vendor quote module, for the uploader's storage folder. */
  readonly VENDOR_QUOTE_MODULE_ID = 12;

  // Item type constants (matching backend and proposal module)
  public CONST_MATERIAL = 1;  // Material/Product
  public CONST_SHIPPING = 4;  // Shipping
  public officeID: any;

  // Stable search-param objects for the item-name search fields.
  // Must be stored on component properties (not bound as inline object literals)
  // so their reference stays stable across change detection — otherwise the
  // scrollable-search-field clears its results on every CD cycle.
  public materialSearchParams: any = {};
  public shippingSearchParams: any = {};

  constructor(
    public dialogService: DialogService,
    public dialogRef: MatDialogRef<AddEditVendorQuotesComponent>,
    public backendApiService: BackendApiService,
    public dialog: NgDialogAnimationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public toasterService: ToasterService,
    public taskDataService: TaskDataService,
    public vendorDataService: VendorDataService,
    private vendorQuoteDataService: VendorQuoteDataService,
    public jobDataService: JobDataService,
    public bidDataService: BidDataService,
    private coreService: CoreService,
    private datePipe: DatePipe,
    public scopeDataService: ScopeDataService,
    public proposalDataService: ProposalDataService,
    public productDataService: ProductDataService
  ) {
    // Extract module and vendor configuration first (before overwriting this.data)
    this.moduleId = data.moduleId
    this.referenceId = data.referenceId
    this.isVendorModule = data.isVendorModule
    this.vendorId = data.vendor?.id || data?.vendorId
    this.isVendorDisabled = data.isVendorDisabled

    // DEBUG: Log received data
    console.log('🔍 AddEditVendorQuotesComponent - Received data:', {
      isVendorModule: this.isVendorModule,
      vendorId: this.vendorId,
      moduleId: this.moduleId,
      referenceId: this.referenceId,
      rawData: data
    });

    // Extract edit mode data
    if (data?.item) {
      this.data = data.item;
      this.vendorQuoteId = data?.item?.id
      this.isEditMode = data.isEditMode
    } else {
      this.data = null;
    }
  }

  public vendorQuoteForm: UntypedFormGroup = new UntypedFormGroup({
    vendor_id: new UntypedFormControl(null, [Validators.required]),
    quotation_reference: new UntypedFormControl(null, [Validators.required]),
    amount: new UntypedFormControl(null, [Validators.required, Validators.min(0.1)]),
    valid_till: new UntypedFormControl(null, [Validators.required]),
    module_id: new UntypedFormControl(null),
    reference_id: new UntypedFormControl(null),
    file_id: new UntypedFormControl(null),
    scopes: new UntypedFormControl(null, [Validators.required]),
  });



  ngOnInit(): void {
    // If Component Trigger from vendor module then vendor dropdown component hide
    if (this.isVendorModule) {
      this.moduleId = 19
      this.getStagesOfModule(this.moduleId)
    }

    // Initialize office ID from local storage
    const currentUser = JSON.parse(localStorage.getItem('current_user') || '{}');
    this.officeID = currentUser?.office_id || currentUser?.tenant_id;

    // Build the item-search params now that officeID is known, and rebuild the
    // material params whenever the vendor changes (so material search stays
    // scoped to the selected vendor).
    this.updateItemSearchParams();
    this.vendorQuoteForm.get('vendor_id')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updateItemSearchParams();
      });

    this.initForm(this.data);
    this.getScopes();

    // If vendorId is provided but data is null (new quote from vendor detail page)
    // Fetch vendor details to populate vendor information
    if (this.vendorId && !this.data) {
      this.getVendorDetails(this.vendorId).subscribe();
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getScopes(){
    this.scopeDataService.userSelectedScopesList()
      .subscribe((response: any) => {
        this.scopes = response.data;
      });
  }

  /**
   * Handle scope selection changes
   */
  onScopeChange(selectedScopes: any[]): void {
    // Scope change handler - no warning needed
  }

  /**
   * OLD METHOD - Replaced by inline search (addItem)
   * Keeping for reference - can be deleted after testing
   */
  /*
  openSelectProductDialog(): void {
    const vendorId = this.vendorQuoteForm.get('vendor_id')?.value;
    const selectedScopes = this.vendorQuoteForm.get('scopes')?.value || [];

    if (!vendorId) {
      this.toasterService.showWarning('Please select a vendor first');
      return;
    }

    if (selectedScopes.length === 0) {
      this.toasterService.showWarning('Please select at least one scope first');
      return;
    }

    this.loadingProducts = true;
    const scopeIds = selectedScopes.map((s: any) => s.id);
    const params: any = {};
    if (scopeIds && scopeIds.length > 0) {
      params.scope_ids = scopeIds.join(',');
    }

    this.backendApiService.getApi(`vendors/${vendorId}/products`, params)
      .subscribe({
        next: (response: any) => {
          const products = response.data?.data || response.data || [];

          if (products.length === 0) {
            this.toasterService.showWarning('No products found for this vendor with selected scopes');
            this.loadingProducts = false;
            return;
          }

          // Add all products with selected=false (unchecked by default)
          products.forEach((product: any) => {
            // Check if product already added
            if (this.selectedProducts.find(p => p.product_id === product.id)) {
              return; // Skip if already added
            }

            const unitPrice = product.pivot?.unit_price || 0;
            const newProduct = {
              product_id: product.id,
              product: product,
              item_name: product.name || product.title,
              description: product.description || '',
              quantity: 1,
              tag: product.code || '',
              unit: product.measurement_unit?.name || product.unit || '',
              unit_price: unitPrice,
              extended_selling: 1 * unitPrice,
              vendor_sub: product.manufacturer?.name || '',
              selected: false // Unchecked by default
            };

            this.selectedProducts.push(newProduct);
          });

          this.loadingProducts = false;
          this.toasterService.showSuccess(`Loaded ${products.length} product(s). Check the boxes to add them to quote.`);
        },
        error: (error) => {
          this.toasterService.showError('Failed to load vendor products');
          this.loadingProducts = false;
        }
      });
  }
  */

  /**
   * OLD METHOD - Replaced by inline search
   * Keeping for reference - can be deleted after testing
   */
  /*
  onProductSelectionChange(index: number): void {
    const product = this.selectedProducts[index];
    if (!product.selected) {
      // If unchecked, reset quantity to 1 and clear description
      product.quantity = 1;
      product.description = '';
      this.calculateExtendedPrice(index);
    }
  }
  */

  /**
   * OLD METHOD - Replaced by removeItem
   * Keeping for reference - can be deleted after testing
   */
  /*
  removeProduct(index: number): void {
    this.selectedProducts.splice(index, 1);
  }
  */

  /**
   * Calculate extended selling price
   */
  calculateExtendedPrice(index: number): void {
    const product = this.selectedProducts[index];
    product.extended_selling = product.quantity * product.unit_price;
  }

  /**
   * Handle quantity change
   */
  onQuantityChange(index: number): void {
    // Whole numbers, at least 1 — the API rejects fractions (quote and proposal quantities are integers).
    const qty = Math.trunc(Number(this.selectedProducts[index].quantity) || 0);
    this.selectedProducts[index].quantity = Math.max(1, qty);
    this.calculateExtendedPrice(index);
  }

  /**
   * Rebuild the (stable-reference) search-param objects used by the Material and
   * Shipping item-name search fields. Reassigning these properties updates the
   * bound reference exactly once per relevant change (e.g. vendor selection),
   * which is what the scrollable-search-field's ngOnChanges expects.
   */
  updateItemSearchParams(): void {
    this.materialSearchParams = {
      tenant_id: this.officeID,
      vendor_id: this.vendorQuoteForm.get('vendor_id')?.value,
    };
    this.shippingSearchParams = {
      type: this.CONST_SHIPPING,
      tenant_id: this.officeID,
    };
  }

  /**
   * Add new item row (Material or Shipping)
   */
  addItem(itemType: number): void {
    const newItem = {
      item_type: itemType,
      item_selected: false,
      product_id: null,
      item_name: '',
      description: '',
      quantity: 1,
      unit: '',
      unit_price: 0,
      extended_selling: 0,
      tag: '',
      selected: true
    };

    this.selectedProducts.push(newItem);
  }

  /**
   * Handle item selection from search
   */
  onItemSelect(selectedItem: any, index: number, itemType: number): void {
    if (!selectedItem) return;

    const item = this.selectedProducts[index];

    if (itemType === this.CONST_MATERIAL) {
      // Material/Product selected
      item.product_id = selectedItem.id;
      item.item_name = selectedItem.full_title || selectedItem.title || selectedItem.name || '';
      item.tag = selectedItem.code || '';
      item.description = selectedItem.description || '';

      // Get unit from measurement_unit object or direct unit property
      item.unit = selectedItem.measurement_unit?.name || selectedItem.unit || '';

      // Get vendor price from vendors array pivot data
      const vendorId = this.vendorQuoteForm.get('vendor_id')?.value;
      const vendorProduct = selectedItem.vendors?.find((v: any) => v.id === vendorId);

      // Try different price fields
      item.unit_price = vendorProduct?.pivot?.unit_price
                     || vendorProduct?.pivot?.unit_price_with_multiplier
                     || vendorProduct?.pivot?.price
                     || selectedItem.unit_price_primary_vendor
                     || selectedItem.price
                     || 0;

    } else if (itemType === this.CONST_SHIPPING) {
      // Shipping selected
      item.product_id = selectedItem.id;
      item.item_name = selectedItem.name;
      item.description = selectedItem.description || '';
      item.unit = selectedItem.unit || 'unit';
      item.unit_price = selectedItem.price || 0;
    }

    item.item_selected = true;
    this.calculateExtendedPrice(index);
  }

  /**
   * Remove item from list
   */
  removeItem(index: number): void {
    this.selectedProducts.splice(index, 1);
  }

  /**
   * Change selected item (reset to search mode)
   */
  changeItem(index: number): void {
    const item = this.selectedProducts[index];
    item.item_selected = false;
    item.product_id = null;
    item.item_name = '';
    item.description = '';
    item.quantity = 1;
    item.unit = '';
    item.unit_price = 0;
    item.extended_selling = 0;
    item.tag = '';
  }

  onModuleSelect(event: MatButtonToggleChange) {
    this.moduleId = event.value
    this.getStagesOfModule(this.moduleId)
  }


  getVendorDetails(vendorId: any) {
    return this.vendorDataService.detail(vendorId).pipe(
      first(),
      map((data) => {
        this.vendorDetail = data.data;
        // Once the inner API call completes successfully, return this.bidDetail
        return this.vendorDetail;
      })
    );
  }


  getStagesOfModule(id: any) {
    this.backendApiService.getApi('stages?module_id=' + id)
      .subscribe((response: any) => {
        this.stages = response.data;
      })
  }


  getFormData = () => {
    if (!this.referenceId || !this.moduleId) {
      this.moduleId = null;
      this.referenceId = null
    }
    const formValue = this.vendorQuoteForm.value;
    console.log('formValue====', formValue);

    // Prepare products array for backend - only include selected/valid items
    const products = this.selectedProducts
      .filter((product: any) => product.selected && product.product_id) // Only send items with product_id
      .map((product: any) => ({
        product_id: product.product_id,
        quantity: product.quantity,
        unit_price: product.unit_price || null,
        description: product.description || '',
        item_type: product.item_type || 1 // 1=Material, 4=Shipping
      }));

    // Prepare attachment IDs array for backend
    const attachmentIds = this.uploadedAttachments.map((att: any) => att.id);

    return {
      vendor_id: formValue.vendor_id,
      quotation_reference: formValue.quotation_reference,
      amount: formValue.amount,
      valid_till: this.coreService.toMomentDate(formValue.valid_till),
      module_id: this.moduleId,
      reference_id: this.referenceId,
      file_id: formValue.file_id, // Keep for backward compatibility
      attachment_ids: attachmentIds, // NEW: Multiple attachments
      scopes: formValue.scopes?.map((scope: any) => scope.id),
      products: products
    };
  }


  save = () => {
    this.touchFormControls();
    if (this.vendorQuoteForm.invalid) {
      console.log('this.vendorQuoteForm', this.vendorQuoteForm);

      return;
    }
    this.saveBulkVendorPricing();
  }

  initForm = (values: any) => {
    const formattedDate = this.datePipe.transform(values?.valid_till, 'yyyy-MM-dd');
    this.vendorQuoteForm.get('quotation_reference')?.setValue(values?.quotation_reference);
    this.vendorQuoteForm.get('vendor_id')?.setValue(this.vendorId ? this.vendorId : values?.vendor?.id);
    this.vendorQuoteForm.get('amount')?.setValue(values?.amount);
    this.vendorQuoteForm.get('module_id')?.setValue(values?.module?.id);
    this.vendorQuoteForm.get('reference_id')?.setValue(values?.reference?.id);
    this.vendorQuoteForm.get('valid_till')?.setValue(formattedDate);
    this.vendorQuoteForm.get('file_id')?.setValue(values?.file?.id);
    this.vendorQuoteForm.get('scopes')?.setValue(values?.scopes);

    // Set uploaded attachments if editing (support both single and multiple)
    this.uploadedAttachments = [];

    // Load multiple attachments from new 'attachments' array
    if (values?.attachments && values.attachments.length > 0) {
      this.uploadedAttachments = values.attachments.map((att: any) => ({
        ...att,
        url: att.attachment || att.url
      }));
    }
    // Fallback to single 'file' for backward compatibility
    else if (values?.file) {
      this.uploadedAttachments = [{
        ...values.file,
        url: values.file.attachment || values.file.url
      }];
    }
    this.uploaderFiles = this.uploadedAttachments.map((att: any) => ({ attach_file: att, attachment_id: att.id }));

    // Populate selected products if in edit mode
    if (values?.products && values.products.length > 0) {
      this.selectedProducts = values.products.map((product: any) => ({
        id: product.id,
        product_id: product.product_id || product.id,
        item_type: product.item_type || 1, // 1=Material, 4=Shipping
        item_selected: true, // Already selected in edit mode
        product: {
          id: product.product_id || product.id,
          name: product.name,
          code: product.code || '',
          manufacturer: { name: product.manufacturer_name || '' },
          unit: product.unit || '',
          pivot: { unit_price: product.unit_price || 0 }
        },
        quantity: product.quantity || 1,
        item_name: product.name,
        description: product.description || '',
        vendor_sub: product.manufacturer_name || '',
        unit: product.unit || '',
        unit_price: product.unit_price || 0,
        extended_selling: (product.quantity || 0) * (product.unit_price || 0),
        tag: product.code || '',
        selected: true // Mark as selected when editing
      }));
    }

    let vendorId = values?.vendor?.id || this.vendorId
    console.log('vendorId', this.vendorId);
    if (vendorId) {
      this.getVendorDetails(vendorId).subscribe();
      // Products will be loaded when user clicks "ADD PRODUCTS" button
    }
  }

  saveBulkVendorPricing() {
    this.isSaving = true;
    const service = this.vendorQuoteId ? this.backendApiService.patchApi(`vendor_quote/${this.vendorQuoteId}`, this.getFormData()) :
      this.backendApiService.postApi('vendor_quote/create', this.getFormData())
    // finalize resets on error too, so a failed save can't leave the button
    // stuck in its spinner state.
    service.pipe(finalize(() => (this.isSaving = false))).subscribe((response: any) => {
      console.log('response', response.data);
      this.toasterService.showSuccessMessage(response.data.message);
      this.close(response.data?.data);
    })
  }


  touchFormControls() {
    Object.keys(this.vendorQuoteForm.controls).forEach(key => {
      this.vendorQuoteForm.get(key)?.markAsTouched();
    });
  }

  close = (data: any = null) => {
    // Only trigger update if there's actual data (indicating a successful save)
    if (data) {
      this.vendorQuoteDataService.setVendorQuoteUpdate(true);
    }
    this.dialogRef.close(data);
  }

  selectedValueChange(event: any) {
    console.log('event', event);
    if (event) {
      this.vendorQuoteForm.get('vendor_id')?.setValue(event?.id);
      // Products will be loaded when user clicks "ADD PRODUCTS" button
    } else {
      this.vendorQuoteForm.get('vendor_id')?.setValue(null);
      this.availableProducts = [];
      this.selectedProducts = []; // Clear selected products if vendor is deselected
    }
  }

  selectedModuleChangeValue(event: any) {
    this.referenceId = event.id
    this.vendorQuoteForm.get('reference_id')?.setValue(event.id);
  }

  createVendor(){
    const dialogRef = this.dialog.open(QuickVendorComponent, {
      width: '500px',
      maxHeight: '80vh',
      panelClass: 'quick-vendor-dialog-container',
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        console.log('result',result);
        this.vendorQuoteForm.get('vendor_id')?.setValue(result?.data?.data.id);
        this.vendorDetail=result?.data?.data
        this.vendorDetail={...this.vendorDetail}
      }
    });
  }

  attachmentId(event: any) {
    const data  = event?.attachment;
    console.log('attachmentId', data);
    this.vendorQuoteForm.get('file_id')?.setValue(data?.attachment_id);
  }

  /**
   * Switch between tabs
   */
  switchTab(tabName: string): void {
    this.activeTab = tabName;
  }

  /**
   * Go to next tab (Information -> Uploads)
   * Saves form data temporarily before switching
   */
  goToNextTab(): void {
    // Mark all fields in Information tab as touched to show validation errors
    this.touchFormControls();

    // Validate required fields for Information tab
    const requiredFields = ['vendor_id', 'quotation_reference', 'amount', 'valid_till', 'scopes'];
    const invalidFields = requiredFields.filter(field => this.vendorQuoteForm.get(field)?.invalid);

    if (invalidFields.length > 0) {
      this.toasterService.showWarning('Please fill all required fields in Information tab');
      return;
    }

    // Save form data temporarily
    this.temporaryFormData = this.getFormData();
    console.log('Temporary form data saved:', this.temporaryFormData);

    // Switch to uploads tab
    this.activeTab = 'uploads';
  }

  /**
   * The system uploader (app-attachment) reports its full list of uploaded files after every
   * upload or removal. Mirror it into `uploadedAttachments` (→ attachment_ids on save) and keep
   * `file_id` = the first file for backward compatibility.
   */
  onAttachmentsChange(event: any): void {
    const data: any[] = Array.isArray(event?.attachment) ? event.attachment : [];
    // Fed back to the uploader so files survive switching between the Information and Uploads tabs.
    this.uploaderFiles = data;
    this.uploadedAttachments = data
      .map((d: any) => ({ ...(d.attach_file || {}), id: d.attachment_id ?? d.attach_file?.id }))
      .filter((att: any) => !!att.id);
    this.vendorQuoteForm.get('file_id')?.setValue(this.uploadedAttachments[0]?.id ?? null);
  }

}